module.exports = __webpack_public_path__ + "assets/img/btn_view.8fa6af40.png";